import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  ADD_TO_WISHLIST,
  FETCH_WISHLIST_ITEMS,
  REMOVE_WISHLIST_ITEM,
} from 'store/actionTypes';
import {
  postWishlists,
  getAllWishlistedItems,
  deleteWishlistItem,
} from 'services/wishlistService';
import {
  addToWishlistSuccess,
  addToWishlistError,
  fetchWishlistItemsSuccess,
  fetchWishlistItemsError,
  removeWishlistItemSuccess,
  removeWishlistItemError,
} from './actions';

function* addWishlist({ payload }) {
  try {
    const response = yield call(postWishlists, payload);
    if (!response.error) {
      yield put(addToWishlistSuccess(response.data));
    } else {
      yield put(addToWishlistError(response.message));
    }
  } catch (error) {
    yield put(addToWishlistError(error));
  }
}

export function* watchAddWishlist() {
  yield takeLatest(ADD_TO_WISHLIST, addWishlist);
}

function* getWishlistItems({ payload }) {
  try {
    const response = yield call(getAllWishlistedItems, payload);
    if (!response.message) {
      yield put(
        fetchWishlistItemsSuccess(response.data, {
          ...payload,
          total: response.totalCount,
        })
      );
    } else {
      yield put(fetchWishlistItemsError(response.message));
    }
  } catch (error) {
    yield put(fetchWishlistItemsError(error));
  }
}

export function* watchFetchWishlistItems() {
  yield takeLatest(FETCH_WISHLIST_ITEMS, getWishlistItems);
}

function* removeWishlistItem({ payload }) {
  try {
    const response = yield call(deleteWishlistItem, payload);
    if (!response.message) {
      yield put(removeWishlistItemSuccess(response.data));
    } else {
      yield put(removeWishlistItemError(response.message));
    }
  } catch (error) {
    yield put(removeWishlistItemError(error));
  }
}

export function* watchRemoveWishlistItem() {
  yield takeLatest(REMOVE_WISHLIST_ITEM, removeWishlistItem);
}

export default function* rootSaga() {
  yield all([
    fork(watchAddWishlist),
    fork(watchFetchWishlistItems),
    fork(watchRemoveWishlistItem),
  ]);
}
